module.exports = __webpack_public_path__ + "static/media/feature-multiple-games2.6e69069d.png";